import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ValidationErrorsDisplayComponent } from './validation-errors-display/validation-errors-display.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ZalamoTooltipModule } from '@ui/zalamo-tooltip/zalamo-tooltip.module';
import { ValidatorHelperDirective } from './validator-helper.directive';
import { MatInputModule } from '@angular/material/input';
import { ButtonModule } from '@ui/button/button/button.module';
import {
  MAT_FORM_FIELD_DEFAULT_OPTIONS,
  MatFormFieldModule,
} from '@angular/material/form-field';
import { CheckboxModule } from '../checkbox/checkbox.module';
import { FormModule } from '../form.module';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatIconModule } from '@angular/material/icon';
import { UnsavedChangesQuestionComponent } from './unsaved-changes-question/unsaved-changes-question.component';

@NgModule({
  declarations: [
    // ExampleValidationComponent,
    ValidationErrorsDisplayComponent,
    ValidatorHelperDirective,
    UnsavedChangesQuestionComponent,
  ],

  imports: [
    FormModule,
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    FormsModule,
    ZalamoTooltipModule,
    MatInputModule,
    ButtonModule,
    CheckboxModule,
    MatSlideToggleModule,
    MatIconModule,

    // MatButtonModule,
  ],
  providers: [
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { appearance: 'outline' },
    },
  ],
  exports: [ValidatorHelperDirective, ValidationErrorsDisplayComponent],
})
export class ValidationModule {}
